<div nz-row>
    <div nz-col nzSpan="24">
        <div [innerHtml]="helpVideo"></div>
    </div>
</div>